import { Avatar, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)`
  border-radius: 0;
  border-width: 0;
  border-bottom-width: 1px;
  height: fit-content !important;
`;

export const Image = styled(Avatar)``;
